import "./teacherlist.css"
import Teacher from "../../components/teacher/Teacher"
const StudentList = () => {
    return (
        <div className="studentList">
            <Teacher />
        </div>
    )
}

export default StudentList
